import React, { ReactElement } from 'react';
import { ContentSetup } from '../utils';
import { forceProblemType, switchModule } from '../redux/actions/progression';
import { APP_CFG, LessonKeys } from '../appcfg';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { useAppDispatch } from '../redux/hooks';

interface CompProps {
  setup: ContentSetup;
}

export const ChoosePage = (props: CompProps): ReactElement => {
  const { setup } = props;
  const dispatch = useAppDispatch();

  const handleSkillSelectChange = (e: SelectChangeEvent<string>): void => {
    const moduleKey = e.target.value as LessonKeys;
    dispatch(switchModule(moduleKey));
  };

  const handleProblemTypeSelectChange = (
    e: SelectChangeEvent<string>
  ): void => {
    const progressionIndex: number = +e.target.value;

    dispatch(forceProblemType([progressionIndex, 0]));
  };

  const handleProblemLevelSelectChange = (
    e: SelectChangeEvent<string>
  ): void => {
    const level: number = +e.target.value;

    dispatch(forceProblemType([setup.progressionIndex, level]));
  };

  const modules = APP_CFG.moduleKeys;
  const subs = setup.moduleInfo.progression[setup.progressionIndex].subs[0];

  return (
    <Box>
      <FormControl
        sx={{
          width: '12em',
          margin: '0 .5em 0 0'
        }}
      >
        <InputLabel id='ChooseSkill'>Choose Skill</InputLabel>
        <Select
          label='Choose Skill'
          labelId='ChooseSkill'
          value={setup.moduleInfo.skill.name}
          onChange={handleSkillSelectChange}
        >
          {modules.map((v, i) => (
            <MenuItem key={i} value={v}>
              {v}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        sx={{
          width: '12em',
          margin: '0 0 0 .5em'
        }}
      >
        <InputLabel id='ChooseProblemType'>Choose Problem Type</InputLabel>
        <Select
          label='Choose Problem Type'
          labelId='ChooseProblemType'
          value={setup.progressionIndex.toLocaleString()}
          onChange={handleProblemTypeSelectChange}
        >
          {setup.moduleInfo.progression.map((v, i) => (
            <MenuItem key={i} value={i.toLocaleString()}>
              {v.contentType}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {subs ? (
        <FormControl
          sx={{
            width: '12em',
            margin: '0 0 0 .5em'
          }}
        >
          <InputLabel id='ChooseProblemType'>Choose Problem Level</InputLabel>
          <Select
            label='Choose Problem Level'
            labelId='ChooseProblemLevel'
            value={setup.difficulty.secondary.toLocaleString()}
            onChange={handleProblemLevelSelectChange}
          >
            {(() => {
              const items: JSX.Element[] = [];
              for (let i = 0; i <= subs; i++) {
                items.push(
                  <MenuItem key={i} value={i.toLocaleString()}>
                    {i.toLocaleString()}
                  </MenuItem>
                );
              }

              return items;
            })()}
            ;
          </Select>
        </FormControl>
      ) : null}
    </Box>
  );
};
